import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App'
import { BrowserRouter, Route, Routes } from 'react-router'
// import Login from './pages/Login.tsx'
import Home from './pages/Home'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        {/* <Route path="home" element={<Home />} /> */}
      </Routes>
    </BrowserRouter>
  </StrictMode>,
)
